import { defineComponent as _defineComponent } from 'vue'
import BKImage from '@/components/AppShared/BKImage.vue'
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'
import { useImage } from '@/shared/composables/image'
import { CalendarEvent } from '../model/types'

interface IProps {
  eventsData: CalendarEvent[]
  activeMobileList: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarMobileEventsList',
  props: {
    eventsData: null,
    activeMobileList: { type: Boolean }
  },
  emits: ["hide-events"],
  setup(__props: any, { emit }: { emit: ({ (e: 'hide-events'): void }), expose: any, slots: any, attrs: any }) {

const { getImageById } = useImage()




function getReformattedDate(date: Date): string {
  return date
    .toLocaleString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    })
    .replace(/ /g, '')
}

return { __sfc: true,getImageById, emit, getReformattedDate, BKImage, BKSvgIcon }
}

})